import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ConfigService } from 'app/services';

@Component({
    selector: 'partner-orders-feedback',
    templateUrl: './partner-orders-feedback.component.html',
    styleUrls: ['./partner-orders-feedback.component.scss'],
    providers: [MessageService]
})
export class PartnerOrdersFeedbackComponent {
    @Input()
    public menuPermissionActive!: string;

    constructor(
        private messageService: MessageService,
        public configService: ConfigService) {
    }
}
